import apiCall from "./apiCall";
// eslint-disable-next-line import/no-anonymous-default-export
export default {
  async create_supplier(data) {
    let response = await apiCall("fuel_suppliers/create", data);
    return response;
  },
  async list_supplier(data) {
    let response = await apiCall("fuel_suppliers/list_suppliers", data);
    return response;
  },
  async list_supplier_mini(data) {
    let response = await apiCall("fuel_suppliers/list_suppliers_mini", data);
    return response;
  },
  async update_supplier(data) {
    let response = await apiCall(
      "fuel_suppliers/update_fuel_suppliers_details",
      data
    );
    return response;
  },
};
